/* Dronelva Shine — animación de aparición de las secciones sh-* */
(function () {
  if (window.shBaseListo) return;
  window.shBaseListo = true;

  var obs = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('sh-visto');
            obs.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px' })
    : null;

  function preparar(raiz) {
    (raiz || document).querySelectorAll('.sh-aparece:not(.sh-visto)').forEach(function (el) {
      if (obs) obs.observe(el);
      else el.classList.add('sh-visto');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { preparar(); });
  else preparar();
  document.addEventListener('shopify:section:load', function (e) { preparar(e.target); });
})();
